import React, { Component, PureComponent, Fragment } from 'react'
import Api from '~/api'
import { Icon } from 'semantic-ui-react'
import { Map, List, fromJS } from 'immutable'
import { connect } from 'react-redux'
import { addListener, removeListener, createNote } from './actions'
import { Button } from 'semantic-ui-react'
import * as LogItems from './logItems'
import moment from 'moment'
import NoteEditor from './note'

export function EventLogItem({ event }) {
  let type = event.get('type')

  let {
    icon = 'bullhorn',
    template = e => e.get('type'),
    info = false,
    color = 'neutral',
    note = false,
  } = LogItems[type] || {}

  let message = typeof template === 'function' ? template.call(null, event) : template

  let created = moment(event.get('created_at'))
  let createdFormatted = created.format('dd DD.MM.YYYY - HH.mm.ss')

  let classes = ['event-log-item']
  classes.push(`event-log-item--color-${color}`)

  if (note) classes.push('event-log-item--note')

  return (
    <div className={classes.join(' ')} key={event.get('id')}>
      <div className="event-log-item-icon">
        <div className="event-log-item-icon-circle">
          <Icon name={icon} />
        </div>
      </div>
      <div className="event-log-item-content">
        <div className="event-log-item-content-inner">
          <div className="event-log-item-message">
            {message}
            {typeof info === 'function' ? (
              <div className="event-log-item-message-info">{info.call(null, event)}</div>
            ) : null}
          </div>
          <div className="event-log-item-info">
            <div className="event-log-item-info-item">
              {moment().diff(created, 'days') < 1 ? created.fromNow() + ' ' : ''}
              {createdFormatted}
            </div>
            <div className="event-log-item-info-item-divider">/</div>
            <div className="event-log-item-info-item">
              {event.getIn(['user', 'name'], event.getIn(['variables', '__inline_ur'], 'Järjestelmä'))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

class EventLog extends Component {
  state = {
    open: false,
  }

  componentDidMount() {
    let { dispatch, id, filters } = this.props
    dispatch(addListener(id, filters))
  }

  // componentWillUnmount() {
  //   let { dispatch, id } = this.props
  //   dispatch(removeListener(id))
  // }

  toggleNotesEditor = (open = false) => {
    let { dispatch, id } = this.props
    dispatch({
      type: 'EVENT_TOGGLE_NOTE_EDITOR',
      id,
      open,
    })
  }

  createNote = value => {
    let { dispatch, id, noteRelations = {} } = this.props

    if (value.trim() === '') return this.toggleNotesEditor()

    dispatch(createNote(id, value, noteRelations))
  }

  render() {
    let { log, id, notes = false } = this.props
    let { open } = this.state

    let data = log.get(id, Map())
    let loading = data.get('loading', true)
    let items = data.get('items', List())
    let meta = data.get('map', Map())
    let noteOpen = data.get('noteEditorOpen', false)
    let noteSaving = data.get('noteEditorSaving', false)

    if (!List.isList(items)) items = List()

    let canFold = items.size > 5
    let isFolded = canFold && !open

    let filteredItems = isFolded ? items.splice(5, items.size) : items

    if (noteOpen)
      return (
        <NoteEditor
          onClose={() => this.toggleNotesEditor(false)}
          onSave={value => this.createNote(value)}
          saving={noteSaving}
        />
      )

    return (
      <div className="event-log">
        <div className="event-log-top">
          {notes ? (
            <div className="event-log-note">
              <button
                className="event-log-note-button"
                onClick={e => e.preventDefault() & this.toggleNotesEditor(true)}>
                <Icon name="sticky note" /> Lisää muistiinpano
              </button>
            </div>
          ) : null}
          <div className="event-log-status">{loading ? <div>Ladataan...</div> : <div>{items.size} kpl</div>}</div>
        </div>
        <div className="event-log-list">
          {filteredItems.map(event => (
            <EventLogItem event={event} key={event.get('id')} />
          ))}
          {isFolded ? <div className="event-log-overlay" /> : null}
        </div>
        {isFolded ? (
          <div className="event-log-action">
            <Button
              content={`Näytä kaikki ${items.size}`}
              size="tiny"
              color="blue"
              onClick={e => e.preventDefault() & this.setState({ open: true })}
            />
          </div>
        ) : null}
      </div>
    )
  }
}

export default connect(state => ({
  log: state.eventLog,
}))(EventLog)
